module.exports = "<div class=\"mat-dialog-content\">\n    <div class=\"select-buttons\">\n        <document-list [link]=\"true\" [documentLink]=\"this.document\" (documentSelected)=\"documentSelected($event)\"></document-list>    </div>\n\n\n</div>\n<div class=\"mat-dialog-actions\"\n     align=\"end\">\n    <button mat-button\n            mat-raised-button\n            [mat-dialog-close]=\"false\">\n        Zavřít\n    </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/DocumentsModule/DocumentLinkDialogComponent/document-link.dialog.component.html
// module id = ../../../../../src/DocumentsModule/DocumentLinkDialogComponent/document-link.dialog.component.html
// module chunks = main